import { render, staticRenderFns } from "./EnvNotifier.vue?vue&type=template&id=5bd594a4&scoped=true"
import script from "./EnvNotifier.vue?vue&type=script&lang=js"
export * from "./EnvNotifier.vue?vue&type=script&lang=js"
import style0 from "./EnvNotifier.vue?vue&type=style&index=0&id=5bd594a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd594a4",
  null
  
)

export default component.exports